import { createContext, useState } from "react";

export const CropImageContext = createContext();

export const CropImageContextProvider = ({ children }) => {
    const [imageToCrop, setImageToCrop] = useState({});
    const [croppedImage, setCroppedImage] = useState({});
    const [isImageCropped, setIsImageCropped] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [imageId, setImageId] = useState('');
    const [aspectRatio, setAspectRatio] = useState(1 / 1);

    const contextValue = {
        imageToCrop,
        setImageToCrop,
        croppedImage,
        setCroppedImage,
        isImageCropped,
        setIsImageCropped,
        modalOpen,
        setModalOpen,
        imageId,
        setImageId,
        aspectRatio,
        setAspectRatio,
    };

    return (
        <CropImageContext.Provider value={ contextValue }>
            { children }
        </CropImageContext.Provider>
    );
}
